export const getUTMParams = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_adset",
  ];

  let utmString = "";
  utmParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      utmString += `&${param}=${encodeURIComponent(value)}`;
    }
  });

  // Extract fbclid and append it as fbclickid
  const fbclid = urlParams.get("fbclid");
  if (fbclid) {
    utmString += `&fbclickid=${encodeURIComponent(fbclid)}`;
  }

  if (utmString) {
    utmString = "?" + utmString.substring(1);
  }

  return utmString;
};

export const appendUTMParams = (url) => {
  const utmParams = getUTMParams();
  if (!utmParams) return url;

  const hasQueryParams = url.includes("?");
  return `${url}${hasQueryParams ? "&" : "?"}${utmParams.substring(1)}`;
};

/**
 * Builds a redirect path with all UTM and tracking parameters preserved
 * @param {string} targetPath - The path to redirect to (e.g., "/", "/some-page")
 * @returns {string} - The path with query parameters appended
 */
export const buildRedirectWithUTM = (targetPath = "/") => {
  if (typeof window === "undefined") {
    return targetPath;
  }

  const urlParams = new URLSearchParams(window.location.search);

  // All tracking parameters
  const trackingParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_adset",
    "fbclid",
    "gclid",
    "gbraid",
    "gad_source",
    "gad_campaignid",
  ];

  const params = new URLSearchParams();

  trackingParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      params.append(param, value);
    }
  });

  const queryString = params.toString();
  if (!queryString) {
    return targetPath;
  }

  const hasQueryParams = targetPath.includes("?");
  return `${targetPath}${hasQueryParams ? "&" : "?"}${queryString}`;
};

/**
 * Appends current URL UTM parameters to any external link
 * @param {string} externalUrl - The external URL to append UTM params to
 * @returns {string} - The URL with UTM parameters appended
 */
export const appendUTMToExternalLink = (externalUrl) => {
  if (typeof window === "undefined" || !externalUrl) {
    return externalUrl;
  }

  const urlParams = new URLSearchParams(window.location.search);

  // All tracking parameters to append
  const trackingParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_adset",
    "fbclid",
    "gclid",
    "gbraid",
    "gad_source",
    "gad_campaignid",
  ];

  const params = new URLSearchParams();

  trackingParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      params.append(param, value);
    }
  });

  const queryString = params.toString();
  if (!queryString) {
    return externalUrl;
  }

  const hasQueryParams = externalUrl.includes("?");
  return `${externalUrl}${hasQueryParams ? "&" : "?"}${queryString}`;
};
